import React from "react";
import contactImage from "../Images/Image/view-heavy-machinery-used-construction-industry (2).jpg";
import "../css/ContactSection.css";

const ContactSection = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      mobile: e.target.mobile.value,
      service: e.target.service.value,
      city: e.target.city.value,
      date: e.target.date.value,
      timestamp: new Date().toLocaleString()
    };

    // Send to Google Sheets using Google Apps Script
    try {
      const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwZP4m_u-1tteuK8jSYTqu2lLRenqlz-Xz0z61Cde13kkVa7VeOz_bEpyjs2Sj9KxSB/exec';
      
      // Create URL with query parameters (alternative method)
      const queryParams = new URLSearchParams(formData).toString();
      const urlWithParams = `${GOOGLE_SCRIPT_URL}?${queryParams}`;
      
      await fetch(urlWithParams, {
        method: 'GET',
        mode: 'no-cors'
      });

      console.log('Response received');
      alert('Form submitted successfully! We will contact you soon.');
      e.target.reset();
    } catch (error) {
      alert('Error submitting form: ' + error.message);
    }
  };

  return (
    <section className="contact-section" style={{ margin: 0, padding: 0 }}>
      
      {/* IMAGE */}
      <div className="contact-image-container">
        <img 
          src={contactImage} 
          alt="Contact Us" 
        />
        <h1>CONTACT US</h1>
      </div>

      {/* TOP INFO BAR */}
      <div className="contact-info-bar">
        <div className="info-box">
          <div className="icon">📞</div>
          <div>
            <h4>Phone Number</h4>
            <p>Mobile: +91 9244202021</p>
          </div>
        </div>

        <div className="info-box dark">
          <div className="icon white">✉</div>
          <div>
            <h4>Email Address</h4>
            <p>management@sktconstruction.in</p>
          </div>
        </div>

        <div className="info-box">
          <div className="icon">📍</div>
          <div>
            <h4>Location</h4>
            <p>Singra Mau, PO, Sahson, Uttar Pradesh 221507</p>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="contact-container">

        {/* LEFT */}
        <div className="contact-left">
          <span className="section-tag">CONTACT US</span>
          <h2>GET IN TOUCH AND<br />CONTACT US !!</h2>

          <p>
            Get in touch with us for any questions or assistance. Contact us
            today to discuss your needs and receive personalized support.
          </p>

          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115006.8!2d81.9894564!3d25.5007201!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399ab3004085b05d%3A0xa96129c2ad06e262!2sSKT%20Construction!5e0!3m2!1sen!2sin!4v1234567890"
            loading="lazy"
            style={{ width: '100%', height: '400px', border: 'none' }}
          ></iframe>
        </div>

        {/* RIGHT FORM */}
        <div className="contact-form-bg">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Book Your Service</h3>

            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <input type="tel" name="mobile" placeholder="Mobile Number" required />

            <select name="service" required>
              <option value="">Select Service</option>
              <option value="Machinery Rental">Machinery Rental</option>
              <option value="Repair & Maintenance">Repair & Maintenance</option>
            </select>

            <input type="text" name="city" placeholder="Enter Your City" required />
            <input type="date" name="date" required />

            <button type="submit">REQUEST FOR A CALL</button>
          </form>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;
